<template>
  <div>
    <HseModalForm v-model="isOpen" :title="$t('select')">
      <template #actions>
        <HseButton :spinner="isLoading" @click="send">
          {{$t('send')}}
        </HseButton>
      </template>
      
      <div class='big-item'>
        <Validator v-bind:field="fields.ScoreSelect" />
        <HseSpace size='small_2x' vertical />
      </div>

    </HseModalForm>
  </div>
</template>

<script>

  import { HseModalForm, HseButton, HseSpace } from '@hse-design/vue' 
  import Validator from '../common/form/Validator.vue'
  import fields from './managerFields'
  import { mapState } from 'vuex'
  import { localizeFields } from '../../i18n'

  export default {
    components: {
      HseModalForm,
      HseButton,
      HseSpace,
      Validator,
    },
    data: () => ({
      isOpen: false,
      isLoading: false,
      fields,
    }),
    created () {
      this.translateFields()
      this.$parent.$on('openScoreModal', () => {this.isOpen = true})
    },
    methods: {
      send() {
            this.isLoading = true;
            this.$emit('openScoreModalResponse', this.fields.ScoreSelect.value)

            setTimeout(() => {
              this.isOpen = false;
              this.isLoading = false;
            }, 200);
          },
      translateFields () {
        this.fields = localizeFields(fields, this.fields)
      }
    },
    computed: mapState(['lang']),
    watch: {
      lang () {
        this.translateFields()
      }
    },   
    i18n: {
      messages: {
        en: {
          send: 'Send',
          select: 'Select a score',
        },
        ru: {
          send: 'Отправить',
          select: 'Выберите оценку',
        },
      }
    } 
  }
</script>

<style scoped>
  .event-card {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 32px;
    max-width: 800px;
    margin: 52px auto;
  }
  .big-item {
    min-height: 400px;
  }
  .link {
    white-space: nowrap;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
  .two-cols {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .three-cols {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 5px;
  }
  .prepull{
    overflow:auto;
  }
  .pull-right {
    float:right;
  }
</style>